import { useQuery } from '@tanstack/react-query'
import {
  type OrganizationWithRole,
  organizationsService,
} from '@/services/organizations'

export const organizationKeys = {
  all: () => ['organizations'] as const,
}

// Sole owner of the ['organizations'] cache entry; two unwrap shapes under one key crashed consumers.
export function useOrganizations() {
  const { data: organizations = [], isLoading } = useQuery<
    OrganizationWithRole[]
  >({
    queryKey: organizationKeys.all(),
    queryFn: () =>
      organizationsService.getOrganizations().then((r) => r.organizations),
  })

  return { organizations, isLoading }
}
